
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 6c2.197 0 4 1.803 4 4 0 .494-.115.969-.281 1.406l6.063 3.438L26.001 9h4L9.72 20.594c.166.438.281.913.281 1.406 0 2.197-1.803 4-4 4s-4-1.803-4-4 1.803-4 4-4c.981 0 1.864.375 2.563.969l5.156-2.938-5.219-2.969c-.691.568-1.543.938-2.5.938-2.197 0-4-1.803-4-4s1.803-4 4-4zm0 2c-.977 0-1.784.677-1.969 1.594A2.088 2.088 0 004 10c0 1.116.884 2 2 2s2-.884 2-2-.884-2-2-2zm13.094 8.813L30 23.001h-4l-8.906-5.094zM6 20c-.977 0-1.784.677-1.969 1.594A2.088 2.088 0 004 22c0 1.116.884 2 2 2s2-.884 2-2-.884-2-2-2z"}})])
          )
        }
      }
    